import { LEAD_ACTIVITY_TYPE_LABELS } from "shared/app/LeadsTableView/slices/LeadsTable/constants";

export const getFilterDisplayName = (filter: string) => {
  // Check if it's an activity type
  if (LEAD_ACTIVITY_TYPE_LABELS[filter])
    return LEAD_ACTIVITY_TYPE_LABELS[filter];

  // Convert snake_case to Title Case as fallback
  return filter
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
